export default {
  key: 'Eb',
  suffix: '13',
  positions: [{
    frets: '0113',
    fingers: '0124'
  }, {
    frets: '5534',
    fingers: '3412'
  }, {
    frets: '6533',
    fingers: '4311',
    barres: 3,
    capo: true
  }, {
    frets: '6788',
    fingers: '1234'
  }]
};